import React, { Fragment } from 'react'
import product1 from '../../Assets/Images/product1.png'
import { useSelector } from 'react-redux'


const ThankYouScreen = () => {
    const cartItems = useSelector(state => state.cart)


    console.log(cartItems)
    return (
        <Fragment >
            <div className="container my-5">
                <div className="row justify-content-center align-items-center flex-column g-2">
                    <div className="col-5">
                        <div className="card rounded-4 bg-light px-5 p-3 border-0 text-center ">
                            <h5>
                                Thank you for Shopping
                            </h5>
                            <p className='s-14'>
                                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab.
                            </p>

                        </div>
                    </div>

                    <div className="col-5 ">
                        <div className="card bg-light px-3 border-0 rounded-4">
                            {cartItems?.cart?.map((item, i) => (
                                <div key={i} className="row align-items-center py-2">
                                    <div className="col-auto">
                                        {item?.img && (
                                            <img
                                                src={item.img}
                                                width="81px"
                                                height="79px"
                                                className="rounded-2"
                                                alt="Product"
                                            />
                                        )}
                                    </div>

                                    <div className="col ps-0">
                                        <div className="row">
                                            <div className="col">
                                                <h5 className="s-17 mb-0">{item?.title || "No Title"}</h5>
                                            </div>
                                            <div className="col-auto">
                                                <h5 className="s-17 fw-500 mb-0">${item?.price || "0.00"}</h5>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-auto">
                                                <p className="s-16 text-muted mb-0">Qty: {item?.quantity || 0}</p>
                                            </div>
                                            <div className="col-auto verticle-border p-0" />
                                            {item?.variant_name && (
                                                <div className="col-auto">
                                                    <p className="s-16 text-muted mb-0">Variant: {item.variant_name}</p>
                                                </div>
                                            )}
                                            <div className="col-auto d-none verticle-border p-0" />
                                            <div className="col-auto d-none">
                                                <p className="s-16 mb-0 text-muted d-flex align-items-center">
                                                    Color: <div className="bg-dark rounded ms-2" style={{ width: "17px", height: "18px" }}></div>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>


                </div>
            </div>
        </Fragment>
    )
}

export default ThankYouScreen